<template>
    <div style="margin-bottom: 10px">
        <v-card class="grey lighten-4">
            <v-layout pa-3 row wrap>
                <v-flex xs6 grow>
                    <p style="color: #535353;"><b>Recibo: </b>{{receiptSingle.code+'/'+receiptSingle.series}}</p>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex shrink class="text-xs-right">
                    <v-btn flat icon color="grey lighten-1" class="text-xs-right" v-if="permissionToDeleteReceipt && !receiptSingle.deleted_at">
                        <v-icon color="red lighten-2" class="text-xs-right" @click="trashReceipt">delete</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex xs6>
                    <span class="grey--text text--darken-1 smallText">Método</span>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs6 class="text-xs-right">
                    <span class="grey--text text--darken-1 smallText">Valor</span>
                </v-flex>

                <v-flex xs12 v-for="payment in receiptSingle.payments" :key="payment.id">
                    <v-layout row wrap>
                        <v-flex grow>
                            <span class="smallTextThin">{{payment.type_payment_method.name}}</span>
                        </v-flex>
                        <v-flex shrink>
                            <span class="smallTextThin">{{payment.value | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</span>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex xs6 class="smallText" style="color: #535353;" v-if="isNeededToShowTotal">
                    <span><b>Total</b></span>
                </v-flex>
                <v-divider></v-divider>
                <v-flex xs6 class="text-xs-right smallText" style="color: #535353;" v-if="isNeededToShowTotal">
                    <span><b>{{ getTotal | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</b></span>
                </v-flex>
                <v-flex xs12>
                    <v-divider></v-divider>
                </v-flex>
                <v-flex shrink>
                    <div v-if="!receiptSingle.deleted_at">
                        <p class="grey--text smallTextThin">Emitido:
                            <br><span><b>Por: </b>{{receiptSingle.user ? receiptSingle.user.name : '---'}}</span>
                            <br><span><b>Em: </b>{{receiptSingle.created_at}}</span>
                        </p>
                    </div>
                    <div v-else>
                        <p class="grey--text smallTextThin">Anulado:
                            <br><span><b>Por: </b>{{receiptSingle.user_who_deleted ? receiptSingle.user_who_deleted.name : '---'}}</span>
                            <br><span><b>Em: </b>{{receiptSingle.deleted_at}}</span>
                            <br><span><b>Motivo: </b>{{receiptSingle.delete_reason}}</span>
                        </p>
                    </div>
                    
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex shrink>
                    <v-btn small outline color="grey" class="white--text" @click="viewReceipt">Ver</v-btn>
                </v-flex>
            </v-layout>

        </v-card>
    </div>
</template>

<script>
    import {eventBus} from "../../main";
    import {Permissions} from "../../config";
    export default {
        name: "Receipt",

        created(){

        },

        data(){
            return {
                Permissions,
                openConfirmationDialog: false,
                loading_modal: false,
            }
        },

        props: ['receiptSingle'],

        computed:{
            permissionToDeleteReceipt(){
                return this.hasPermission(Permissions.INVOICE_RECEIPT_DELETE);
            },
            showReceiptPaperModal: {
                get() {
                    return this.$store.getters.getShowReceiptPaperModal;
                },
                set(value) {
                    this.$store.dispatch('setShowReceiptPaperModal', value);
                }
            },
            selectedReceipt: {
                get() {
                    return this.$store.getters.getSelectedReceipt;
                },
                set(value) {
                    this.$store.dispatch('setSelectedReceipt', value);
                }
            },
            getTotal(){
                let total = 0;
                for(let i=0; i<this.receiptSingle.payments.length; i++){
                    total += this.receiptSingle.payments[i].value;
                }
                return total;
            },

            isNeededToShowTotal(){
                return this.receiptSingle.payments.length > 1;
            }
        },

        methods: {
            viewReceipt(){
                this.showReceiptPaperModal = true;
                this.selectedReceipt = this.receiptSingle;
                eventBus.$emit('onReceiptPaperOpen');
            },

            trashReceipt(){
                this.openConfirmationDialog = true;
                eventBus.$emit('onTrashingReceipt', this.receiptSingle.id, this.receiptSingle.code, this.receiptSingle.series);
            },

            confirmationDialogYes(){
                this.loading_modal = true;
            },

            close(){
                this.openConfirmationDialog = false;
                this.loading_modal = false;
            }
        }

    }
</script>

<style scoped>
    .smallTextThin{
        font-size: 12px;
        margin-top: -8px;
        padding-top: -8px;
    }
    .smallText{
        font-size: 13px;
    }
</style>